module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('ul', {
    ref: "fleest",
    class: ['fleet-list']
  }, _vm._l((_vm.fleets), function(fleet, index) {
    return _c('li', [_c('a', {
      class: {
        'selectedFleet': index == _vm.selected.fleetIndex
      },
      attrs: {
        "href": "#"
      },
      on: {
        "click": function($event) {
          $event.preventDefault();
          _vm.selectFleet(index);
          _vm.scrollList();
        }
      }
    }, [_vm._v(_vm._s(fleet.name))])])
  }), 0)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// C:/PhpstormProjects/e-crewing/~/vue-loader/lib/template-compiler.js?id=data-v-304ccebc!C:/PhpstormProjects/e-crewing/~/vue-loader/lib/selector.js?type=template&index=0!./vue/fleet/components/Fleets.vue
// module id = 166
// module chunks = 3